
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newhomes",
      function () {
        return require("private-next-pages/newhomes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newhomes"])
      });
    }
  